import { FaBoxOpen, FaDatabase, FaFileInvoiceDollar, FaGear, FaHexagonNodes, FaHouse, FaLifeRing, FaMoneyBillWave, FaUserGear, FaWifi } from "react-icons/fa6";

export const NavLinkItemTeknisi = [
    { id: 1, name: "Dashboard", icon: FaHouse, path: "/dashboard-menu", type: "link" },
    {
      name: "Master Data", icon: FaDatabase, type: "accordion",
      subItems: [
        { name: "NAS / Mikrotik", path: "/dashboard/master-data/nas" },
        { name: "OLT", path: "/dashboard/master-data/olt" },
        { name: "POP", path: "/dashboard/master-data/pop" },
        { name: "ODC", path: "/dashboard/master-data/odc" },
        { name: "ODP", path: "/dashboard/master-data/odp" },
        { name: "Mapping", path: "/dashboard/master-data/mapping" },
      ],
    },
    {
      id: 3, name: "PPPoE", icon: FaWifi, type: "accordion",
      subItems: [
        { id: 3.1, name: "Profile", path: "/dashboard/pppoe/profile" },
        { id: 3.2, name: "User", path: "/dashboard/pppoe/user" },
        { id: 3.3, name: "PSB", path: "/dashboard/pppoe/psb" },
      ],
    },
    {
      name: "Invoice", icon: FaBoxOpen, type: "accordion",
      subItems: [
        { name: "Group", path: "/dashboard/invoice/group" },
        { name: "List", path: "/dashboard/invoice/list" },
        { name: "Janji Bayar", path: "/dashboard/invoice/promise-to-pay" },
      ],
    },
    { id: 9, name: "Tiket Gangguan", icon: FaLifeRing, path: "/dashboard/ticket", type: "link" },
    { id: 12, name: "Pengaturan", icon: FaGear, path: "/dashboard/setting", type: "link" },
  ];